export enum Message {
  APPROVE_CHANGES = 'MESSAGE_APPROVE_CHANGES',
  CLOSE_ORDER = 'MESSAGE_CLOSE_ORDER',
  CREATION_DISCLAIMED = 'MESSAGE_ENTITY_CREATION_DISCLAIMED',
  CREATION = 'MESSAGE_ENTITY_CREATION',
  DELETION = 'MESSAGE_ENTITY_DELETION',
  DELETION_DISCLAIMED = 'MESSAGE_ENTITY_DELETION_DISCLAIMED',
  EXPORT_DATA = 'MESSAGE_EXPORT_DATA',
  GENERATE_REPORT = 'MESSAGE_GENERATE_REPORT',
  LOGIN_SUCCESS = 'MESSAGE_LOGIN_SUCCESS',
  LOGIN_SUCCESS_FIRST_FACTOR = 'MESSAGE_LOGIN_SUCCESS_FIRST_FACTOR',
  LOGIN_SUCCESS_PWD_RESET = 'MESSAGE_LOGIN_SUCCESS_PWD_RESET',
  MODIFICATION = 'MESSAGE_ENTITY_MODIFICATION',
  MODIFICATION_DISCLAIMED = 'MESSAGE_ENTITY_MODIFICATION_DISCLAIMED',
  PASSWORD_RESET = 'MESSAGE_PASSWORD_RESET',
  REJECT_CHANGES = 'MESSAGE_REJECT_CHANGES',
  REOPEN_ORDER = 'MESSAGE_REOPEN_ORDER',
  RESET_AUTHENTICATOR = 'MESSAGE_RESET_AUTHENTICATOR',
  RESET_PASSWORD = 'MESSAGE_RESET_PASSWORD',
  SIGN_ORDER = 'MESSAGE_SIGN_ORDERS',
  UNPUBLISH_CHANGES = 'MESSAGE_UNPUBLISH_CHANGES',
  UNSIGN_ALL_ORDER = 'MESSAGE_UNSIGN_ALL_ORDER',
  UNSIGN_ORDER = 'MESSAGE_UNSIGN_ORDER',
  UPLOAD_PAYMENT_FILE = 'MESSAGE_UPLOAD_PAYMENT_FILE',
  UNLOCK_USER = 'MESSAGE_UNLOCK_USER',
  AUTORELEASE_ORDER = 'MESSAGE_AUTORELEASE_ORDER',
}
